import React, { useState, useEffect, useMemo } from "react";
import { ReconBills } from "../../pages";
import { BillsController } from "../../controllers";

const ReconBillsContainer = () => {
  const [loading, setLoading] = useState(false);
  const [billRecon, setBillRecon] = useState(false);
  const [billItem, setBillItem] = useState({});
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const billReconTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    BillsController.useGetBillsReconciliation(
      billReconTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const goToBillReconModal = (item) => {
    setBillRecon(true);
    setBillItem(item);
  };

  const closeModal = () => {
    setBillRecon(false);
  };

  return (
    <ReconBills
      loading={loading}
      billRecon={billRecon}
      goToBillReconModal={goToBillReconModal}
      closeModal={closeModal}
      billItem={billItem}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setFilterQuery={setFilterQuery}
      setSearchQuery={setSearchQuery}
    />
  );
};
export default ReconBillsContainer;
